import React from "react";
import { useHistory } from "react-router-dom";
import FirstStepTutorial from "./components/FirstStepTutorial";
import TutorialSteps from "./components/TutorialSteps/TutorialSteps";

const OfflineTutorial = () => {
  const history = useHistory();
  const [showTutorial, setShowTutorial] = React.useState<boolean>(false);

  const haveSeenTutorial = localStorage.getItem('haveSeenTutorial');
  if (haveSeenTutorial) history.push('/login');

  return (
    <>
      {showTutorial && (
        <TutorialSteps />
      )}
      {!showTutorial && (
        <FirstStepTutorial showTutorial={() => { setShowTutorial(true) }} />
      )}
    </>
  );
}

export default OfflineTutorial;
